/**
 * Service Worker registration helper.
 * Registers /sw.js (served from public root) in production AND in the
 * Emergent preview env. We avoid registering during `npm start --hot` of
 * a developer's local machine because CRA dev assets aren't long-lived.
 */
export const registerServiceWorker = () => {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Avoid SW in CRA dev mode (localhost without HTTPS), but DO register in
  // preview and prod where the app is served over HTTPS.
  const isLocalDev =
    window.location.hostname === 'localhost' &&
    window.location.protocol === 'http:';
  if (isLocalDev) return;

  // Wait for `load` so SW install doesn't compete with critical render.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Quietly check for updates every 30 minutes
        setInterval(() => {
          try { reg.update(); } catch (_) { /* noop */ }
        }, 30 * 60 * 1000);
      })
      .catch(() => { /* swallow — SW is enhancement, not requirement */ });
  });
};
